import * as moment from 'moment-timezone';

export class ScholasticYear {
  private static readonly SCHOOL_YEAR_START_MONTH: number = 6; // (0-based)
  private static readonly SCHOOL_YEAR_START_DAY: number = 24;
  private static readonly TZ = moment.tz.guess();

  // Ritorna la data che determina il cambio anno scolastico all'interno di Ring
  public static getSchoolYearSwitchDate(momentDate?: moment.Moment) {
    momentDate ??= moment.tz(this.TZ);
    return moment.tz(
      {
        year: momentDate.year(),
        month: this.SCHOOL_YEAR_START_MONTH,
        day: this.SCHOOL_YEAR_START_DAY,
      },
      this.TZ,
    );
  }

  // Ritorna l'anno di inizio dell'anno scolastico della data passata
  public static getSchoolYearStartYear = (momentDate?: moment.Moment) => {
    momentDate ??= moment.tz(this.TZ);
    const switchDate = this.getSchoolYearSwitchDate(momentDate);
    return momentDate.isSameOrAfter(switchDate)
      ? momentDate.year()
      : momentDate.year() - 1;
  };

  public static getCurrent(): string {
    const startYear = this.getSchoolYearStartYear(moment.tz(this.TZ));
    return `${startYear}-${startYear + 1}`;
  }

  public static getCurrentEndDate(tz?: string): moment.Moment {
    const defaultTZ = 'Europe/Rome';
    const endDate = moment
      .tz(`${this.getCurrent().split('-')[1]}-06-22`, tz ?? defaultTZ)
      .endOf('day');
    return endDate;
  }

  public static getFromCurrent(number: number): string {
    const scholasticYear: string = this.getCurrent();
    const years: string[] = scholasticYear.split('-');
    if (years.length != 2) return 'ERROR';
    return `${parseInt(years[0]) + number}-${parseInt(years[1]) + number}`;
  }
  // Shortcut
  public static getPrev(): string {
    return this.getFromCurrent(-1);
  }
  // Shortcut
  public static getNext(): string {
    return this.getFromCurrent(1);
  }
}
